<!--
  @url: /order/refund/apply-for-refund
  @author: lentoo
  @created 2019/04/02 10:59:36
  @description: 申请退款页面
-->
<template>
  <cc-container class="apply-for-refund">
    <cc-header-nav title="申请退款"></cc-header-nav>
    <cc-main>
      <cc-card>
        <div class="form">
          <van-cell-group>
            <van-field
              v-model="price"
              required
              clearable
              label="退款金额："
              type="number"
              @blur="handleBlur"
              placeholder="请输入退款金额"  />
            <van-field
              v-model="reason"
              required
              clearable
              ref="reason"
              @focus="showActionSheet = true; $refs.reason.blur()"
              label="退款原因："
              placeholder="请选择退款原因"  />
            <van-field
              v-model="desc"
              clearable
              label="退款说明："
              type="textarea"
              autosize
              rows="3"
              placeholder="请输入退款说明"  />
          </van-cell-group>
        </div>
      </cc-card>

      <section class="summary-box">
        <div>
          <p class="pl10">
            本单总合计：<span class="price">￥{{summaryPrice}}</span>
          </p>
        </div>
        <div>
          <van-button
            style="background: #1BB0D9;border-color: #1BB0D9;"
            size="small"
            type="primary"
            @click="submit"
          >提交申请</van-button>
        </div>
      </section>

      <van-actionsheet
        v-model="showActionSheet"
        :actions="actions"
        @select="onSelect"
      />
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { Button, Field, CellGroup, Actionsheet, Toast } from 'vant'
import { mapActions, mapGetters } from 'vuex'

import { types } from '../../../../store/modules/order'
Vue.use(Field).use(CellGroup).use(Actionsheet).use(Toast).use(Button)
export default {
  name: 'apply-for-refund',

  data () {
    return {
      id: this.$route.query.id || 0,
      type: 0, // 0 表示退款 1 表示退货
      price: '',
      reason: '',
      desc: '',
      showActionSheet: false,
      actions: [],
      summaryPrice: ''
    }
  },
  computed: {
    ...mapGetters(['getSubmitInfo', 'submitRefund'])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions([types.GET_SUBMIT_INFO, types.SUBMIT_REFUND]),
    async loadData () {
      const type = this.type
      await this.GET_SUBMIT_INFO({
        type,
        from_id: this.id
      // }).catch((err) => {
      }).catch(() => {
        // console.log('err', err)
        setTimeout(() => {
          history.go(-1)
        }, 3000)
      })
      if (!this.getSubmitInfo.data) {
        return
      }
      this.getSubmitInfo.data.reason.map(reason => {
        this.actions.push({
          name: reason
        })
      })
      this.detail = this.getSubmitInfo.data
      // this.price = this.detail.order_amount
      this.summaryPrice = this.getSubmitInfo.data.order_amount
    },
    onSelect ({ name }) {
      this.reason = name
      this.showActionSheet = false
    },
    handleBlur () {
      if (this.price > this.summaryPrice) {
        Toast('退款金额不能超过订单支付金额')
        this.price = this.summaryPrice
      }
    },
    /**
     * @description 提交申请
     */
    async submit () {
      if (this.reason === '') {
        Toast('请选择退货原因')
        return
      }
      if (this.price === '') {
        Toast('请输入退款金额')
        return
      }
      if (parseFloat(this.price) === 0) {
        Toast('退款金额不能为0')
        return
      }
      await this.SUBMIT_REFUND({
        from_id: this.id,
        price: this.price,
        reason_desc: this.desc,
        reason_info: this.reason
      })
      this.$tips(this.submitRefund, {
        tip: true
      }, () => {
        setTimeout(() => {
          this.$router.replace('/order/refund')
        }, 1000)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/index.scss';
.apply-for-refund {
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin-top: 8px;
    margin-bottom: 10px;
    justify-content: space-between;
    padding-right: 10px;
    .checkbox {
      padding-left: 5px;
    }
    .price {
      color: $price-color;
      font-size: 14px;
      line-height: 1;
    }
    .count {
      color: $heading-color;
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
